import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_THREAD_LIST_IDENTIFICATION = createAsyncActionTypes('FETCH_THREAD_LIST_IDENTIFICATION');